export default "__VITE_ASSET__BLHTRIoh__"